"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedCoverageDisplay = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var get_1 = __importDefault(require("lodash/get"));
var omit_1 = __importDefault(require("lodash/omit"));
var react_1 = __importDefault(require("react"));
var embedded_coverage_1 = require("../../schema-input/components/embedded-coverage");
var group_1 = require("../group");
var label_1 = require("../label");
var value_1 = require("../value");
function EmbeddedCoverageDisplay(_a) {
    var _b, _c, _d, _e, _f;
    var name = _a.name, schema = _a.schema, value = _a.value;
    var schemaEntries = Object.entries(schema.properties || {});
    var limitsSchema = (_b = schema.properties) === null || _b === void 0 ? void 0 : _b.limit;
    return (react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center" },
        react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column", marginRight: 12 },
            react_1.default.createElement(core_ui_1.FlexCell, { width: 250 },
                react_1.default.createElement(label_1.Label, { label: schema.inputMetadata.label })),
            react_1.default.createElement(core_ui_1.FlexCell, null, value.type === embedded_coverage_1.LimitOptions.LIMIT && ((_c = limitsSchema === null || limitsSchema === void 0 ? void 0 : limitsSchema.properties) === null || _c === void 0 ? void 0 : _c.limitApplies) && (react_1.default.createElement(value_1.Value, { color: "dark", size: "regular", weight: 300, name: name, field: (_d = limitsSchema.properties) === null || _d === void 0 ? void 0 : _d.limitApplies, value: (_e = value === null || value === void 0 ? void 0 : value.limit) === null || _e === void 0 ? void 0 : _e.limitApplies })))),
        react_1.default.createElement(core_ui_1.Spacing, { width: 12 }),
        value.type === embedded_coverage_1.LimitOptions.LIMIT && (react_1.default.createElement(core_ui_1.FlexCell, null,
            react_1.default.createElement(core_ui_1.Stack, { gap: 16, direction: "horizontal" }, schemaEntries.map(function (_a, index) {
                var _b;
                var key = _a[0], nestedSchema = _a[1];
                // type is never rendered
                if (key === 'type') {
                    return null;
                }
                // if value is missing, skip it
                if (!value[key]) {
                    return null;
                }
                // deductible type and limitApplies should not appear in this section
                var actualSchema = getActualSchema(key, nestedSchema);
                return (react_1.default.createElement("div", { key: key },
                    react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(label_1.Label, { label: overrideDeductiblesLabel(value, key, nestedSchema), name: key })),
                        react_1.default.createElement(core_ui_1.FlexCell, null,
                            react_1.default.createElement(core_ui_1.Stack, { gap: 12, direction: "vertical" }, (_b = actualSchema.layout) === null || _b === void 0 ? void 0 : _b.map(function (group, ind) { return (react_1.default.createElement(group_1.SchemaDisplayGroup, { key: name + "-SchemaDisplayGroup-item-identifier-" + (ind + 1), group: group, name: name, schema: actualSchema, values: (value[key] || {}) })); }))))));
            })))),
        !value.type && (react_1.default.createElement(core_ui_1.FlexCell, null,
            react_1.default.createElement(core_ui_1.Text, { weight: 300 }, "Unknown"))),
        value.type && value.type !== embedded_coverage_1.LimitOptions.LIMIT && ((_f = schema.properties) === null || _f === void 0 ? void 0 : _f.type) && (react_1.default.createElement(core_ui_1.FlexCell, null,
            react_1.default.createElement(value_1.Value, { name: name, field: schema.properties.type, value: value === null || value === void 0 ? void 0 : value.type })))));
}
exports.EmbeddedCoverageDisplay = EmbeddedCoverageDisplay;
function getActualSchema(schemaKey, schema) {
    var _a;
    // limitApplies is not part of the standard display
    if (schemaKey === 'limit') {
        return (0, omit_1.default)(schema, ['properties.limitApplies']);
    }
    // we're not gonna render deductibleType, but use it as the label instead
    var schemaWithoutDeductibleType = (0, omit_1.default)(schema, ['properties.deductibleType']);
    var withoutLayoutField = __assign(__assign({}, schemaWithoutDeductibleType), { layout: ((_a = schemaWithoutDeductibleType === null || schemaWithoutDeductibleType === void 0 ? void 0 : schemaWithoutDeductibleType.layout) === null || _a === void 0 ? void 0 : _a.filter(function (group) {
            if (((group === null || group === void 0 ? void 0 : group.inputs) || []).includes('deductibleType') && ((group === null || group === void 0 ? void 0 : group.inputs) || []).length === 1) {
                return false;
            }
            return __assign(__assign({}, group), { inputs: ((group === null || group === void 0 ? void 0 : group.inputs) || []).filter(function (inputKey) { return inputKey !== 'deductibleType'; }) });
        })) || [] });
    return withoutLayoutField;
}
/**
 * This is a very specific display logic for this component, depending on the deductibleType field value
 * we want to change the label of the schema below.
 *
 * TODO: research on how this could be done dynamically and driven by the backend
 */
function overrideDeductiblesLabel(values, schemaKey, schema) {
    var _a;
    if (schemaKey === 'limit') {
        return (_a = schema === null || schema === void 0 ? void 0 : schema.inputMetadata) === null || _a === void 0 ? void 0 : _a.label;
    }
    if ((0, get_1.default)(values, schemaKey + ".deductibleType") === 'RETENTION') {
        return 'Retention';
    }
    return 'Deductible';
}
